/**
 * =============================================================================
 * GA4 — Chien dich chung THADINGYUT 2026 (ShweDeal)
 * Ma yeu cau: GA4_REQ_thadingyut_202609_01
 * Nguon khai bao: GA4_KhaiBao_Thadingyut_2026.xlsx — sheet 12_KB_Event ba dich vu
 *
 * BE MAT DUY NHAT tren ShweDeal web-v3: icon cross-service cau hinh tu CMS
 * (API_PATH.crossIcons -> bang CROSS_ICON), render trong khay duoi cung
 * <SocialLinks /> o trang Home. KHONG co popup gioi thieu khi bam icon,
 * nen chi dung creative_slot = thadingyut_home_icon.
 *
 * RANG BUOC BAT BUOC (sheet 12)
 *  - Moi event gui kem: promotion_id, service_id, environment
 *  - Link sang trang chien dich KHONG gan utm_*, chi gan tham so thuong ?src=
 *  - Khong co MSISDN / so dien thoai o bat ky tham so nao
 *  - Ba tham so noi phai khop trang chien dich: promotion_id, service_id, mission_id
 * =============================================================================
 */

/* ------------------------------------------------------------------ hang so */

export const THD = {
  promotion_id: "thadingyut_2026",
  service_id: "shwedeal", // PIC xac nhan: khop source_service/target_service ben trang chien dich
  get environment() {
    // prod | staging — dung de loc du lieu kiem thu khoi dashboard chien dich
    const v = process.env.REACT_APP_GA4_ENV;
    if (v === "prod" || v === "staging") return v;
    return process.env.NODE_ENV === "production" ? "prod" : "staging";
  },
};

/** Ba be mat quang ba theo sheet 12. ShweDeal chi dung HOME_ICON. */
export const SLOT = {
  HOME_ICON: "thadingyut_home_icon",
  INTRO_POPUP: "thadingyut_intro_popup", // khong dung: bam icon la chuyen huong ngay
  RANDOM_POPUP: "thadingyut_random_popup", // khong dung
};

/** Nguong "trong vung nhin thay" — chot chung cho ca ba dich vu. */
export const VIEW_RATIO = 0.5; // 50% dien tich icon
export const VIEW_DWELL = 1000; // lien tuc 1000 ms

/**
 * Khay SocialLinks tu thu gon sau 4 giay va nguoi dung co the keo mo/dong
 * nhieu lan. Neu dem moi lan khay mo thi THD-01 bi lan hanh vi keo khay chu
 * khong con thuan la "bao nhieu nguoi thay icon".
 *
 *   true  -> MOT lan moi luot vao trang Home  (dang dung)
 *   false -> dem moi lan icon roi khoi roi vao lai vung nhin thay (dung luat TC-01)
 *
 * Doi mot dong nay la doi duoc cach dem, khong phai sua logic.
 */
export const IMPRESSION_ONCE_PER_PAGE = true;

/** Host cua trang chien dich. Icon CMS nao dan ve day thi duoc do luong. */
export const PROMO_HUB_HOSTS = ["shwefest.magicwheel.com.mm"];

/** Tham so cua deep link co the boc URL that ben trong. */
const DEEPLINK_URL_KEYS = ["ref", "url", "link", "target", "redirect"];

/* -------------------------------------------------------------------- push */

/** Day event len dataLayer kem 3 tham so chung cua sheet 12. */
export function thdPush(eventName, params) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const payload = {
    event: eventName,
    promotion_id: THD.promotion_id,
    service_id: THD.service_id,
    environment: THD.environment,
  };
  if (params) {
    Object.keys(params).forEach((k) => {
      if (params[k] !== undefined) payload[k] = params[k];
    });
  }
  window.dataLayer.push(payload);
}

/* ----------------------------------------------------------------- helpers */

/** platform_type — giu dung quy uoc san co cua ShweDeal. */
export function platformType() {
  if (typeof navigator === "undefined") return "web";
  const ua = navigator.userAgent || "";
  if (/Android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  return "web";
}

const warned = typeof Set === "function" ? new Set() : null;

/** Canh bao MOT lan cho moi gia tri href bi sai dinh dang (chi o dev). */
function warnOnce(original, fixed) {
  if (process.env.NODE_ENV === "production") return;
  if (warned) {
    if (warned.has(original)) return;
    warned.add(original);
  }
  // eslint-disable-next-line no-console
  console.warn(
    "[Thadingyut GA4] href trong CMS sai dinh dang:\n  " +
      original +
      "\n  -> da tu chuan hoa thanh: " +
      fixed +
      "\n  PIC can sua lai gia tri trong CMS (CrossIcon)."
  );
}

/**
 * Chuan hoa mot gia tri href thanh URL http(s) tuyet doi.
 *
 * PIC nhap tay vao CMS nen thuong gap ba dang sai. Neu khong chuan hoa,
 * the <a href> se duoc trinh duyet coi la duong dan TUONG DOI va ghep vao
 * origin hien tai, vi du "http//shwefest.magicwheel.com.mm/?src=shwedeal"
 * bien thanh "http://localhost:3000/http//shwefest.magicwheel.com.mm/?src=shwedeal".
 *
 * Tra ve "" neu day khong phai URL web (deep link mytel://, tel:, "#", ...).
 */
export function normalizeUrl(url) {
  if (!url) return "";
  const s = String(url).trim();
  if (!s || s === "#") return "";

  // Dung roi
  if (/^https?:\/\//i.test(s)) return s;

  // 1) Thieu dau hai cham:  "http//host"  ->  "http://host"
  const m = s.match(/^(https?)\/\/(.+)$/i);
  if (m) {
    const fixed = m[1].toLowerCase() + "://" + m[2];
    warnOnce(s, fixed);
    return fixed;
  }

  // 2) Protocol-relative:  "//host"  ->  "https://host"
  if (s.indexOf("//") === 0) {
    const fixed = "https:" + s;
    warnOnce(s, fixed);
    return fixed;
  }

  // 3) Thieu han scheme:  "host.com/x"  ->  "https://host.com/x"
  if (/^[a-z0-9-]+(\.[a-z0-9-]+)+([/?#]|$)/i.test(s)) {
    const fixed = "https://" + s;
    warnOnce(s, fixed);
    return fixed;
  }

  return "";
}

/**
 * Tra ve URL http(s) THAT ma link nay dan tới.
 *
 * CMS co the cau hinh href_mobile la deep link boc URL that ben trong, vi du
 *   mytel://webgamemyid?ref=http%3A%2F%2Fmagicwheel.com.mm%2F
 * Neu chi doc host cua chinh no thi ra "webgamemyid" -> mat do luong.
 */
export function resolveTargetUrl(url) {
  if (!url) return "";

  // 0) chinh no la URL web (ke ca dang nhap sai da duoc chuan hoa)
  const direct = normalizeUrl(url);
  if (direct) return direct;

  // 1) doc tham so mang URL ben trong deep link
  const q = url.indexOf("?");
  if (q !== -1) {
    try {
      const params = new URLSearchParams(url.slice(q + 1));
      for (let i = 0; i < DEEPLINK_URL_KEYS.length; i += 1) {
        const inner = normalizeUrl(params.get(DEEPLINK_URL_KEYS[i]));
        if (inner) return inner;
      }
    } catch (e) {
      /* bo qua, thu cach 2 */
    }
  }

  // 2) giai ma toan bo roi tim URL http dau tien (chap ca dang thieu dau hai cham)
  try {
    const decoded = decodeURIComponent(url);
    const m = decoded.match(/https?:?\/\/[^\s&"'<>]+/i);
    if (m) return normalizeUrl(m[0]);
  } catch (e) {
    /* url khong decode duoc */
  }

  return "";
}

/** Icon CMS nay co phai icon chien dich Thadingyut khong? */
export function isThadingyutIcon(url) {
  const target = resolveTargetUrl(url);
  if (!target) return false;
  try {
    const host = new URL(target).hostname.toLowerCase();
    return PROMO_HUB_HOSTS.some((h) => host === h || host.endsWith("." + h));
  } catch (e) {
    return false;
  }
}

/** Gan ?src= vao mot URL http(s), khong ghi de neu da co. */
function addSrc(httpUrl, src) {
  try {
    const u = new URL(httpUrl);
    if (!u.searchParams.get("src")) u.searchParams.set("src", src);
    return u.toString();
  } catch (e) {
    if (/[?&]src=/.test(httpUrl)) return httpUrl;
    return (
      httpUrl +
      (httpUrl.indexOf("?") === -1 ? "?" : "&") +
      "src=" +
      encodeURIComponent(src)
    );
  }
}

/**
 * Gan tham so thuong ?src=shwedeal vao link CMS.
 *
 * TUYET DOI KHONG gan utm_* — gan utm se cat phien va ghi de nguon truy cap
 * that, lam sai THD-08 va THD-21 (kich ban TC-05, TC-19, TC-20).
 *
 * Voi deep link, ?src= duoc gan vao URL BEN TRONG roi encode lai, vi trang
 * chien dich chi doc duoc query cua chinh no.
 */
export function withSrcParam(url, src) {
  if (!url) return url;
  const s = src || THD.service_id;

  // Link web (ke ca dang nhap sai): tra ve URL TUYET DOI da chuan hoa, neu
  // khong the <a href> se bi coi la duong dan tuong doi va ghep vao localhost.
  const direct = normalizeUrl(url);
  if (direct) return addSrc(direct, s);

  // Deep link: gan ?src= vao URL BEN TRONG roi encode lai, vi trang chien dich
  // chi doc duoc query cua chinh no.
  const q = url.indexOf("?");
  if (q !== -1) {
    try {
      const params = new URLSearchParams(url.slice(q + 1));
      for (let i = 0; i < DEEPLINK_URL_KEYS.length; i += 1) {
        const rawInner = params.get(DEEPLINK_URL_KEYS[i]);
        const inner = normalizeUrl(rawInner);
        if (!inner) continue;

        const innerWithSrc = addSrc(inner, s);
        if (innerWithSrc === rawInner) return url;

        // rawInner nam trong url duoi dang da percent-encode
        const rawEnc = encodeURIComponent(rawInner);
        if (url.indexOf(rawEnc) !== -1) {
          return url.replace(rawEnc, encodeURIComponent(innerWithSrc));
        }
        if (url.indexOf(rawInner) !== -1) {
          return url.replace(rawInner, innerWithSrc);
        }
        return url;
      }
    } catch (e) {
      /* url khong parse duoc -> giu nguyen */
    }
  }

  return url; // mytel://back, tel:, khong boc URL nao
}

/* --------------------------------------------------------------- tracking */

/**
 * Ban select_promotion + exit_to_promo_hub khi nguoi dung bam icon chien dich.
 *
 * @param {string} rawUrl link CMS (da chon theo thiet bi)
 * @param {boolean} opensNewTab link http mo tab moi (target="_blank")?
 *        - true : trang hien tai KHONG unload -> ban roi de trinh duyet tu mo tab
 *        - false: dieu huong cung tab -> phai cho eventCallback cua GTM
 * @returns {boolean} true neu ham nay se tu lo viec chuyen huong
 *          (chi xay ra khi opensNewTab = false)
 */
export function trackPromoExit(rawUrl, opensNewTab) {
  if (!isThadingyutIcon(rawUrl)) return false;

  const params = {
    creative_slot: SLOT.HOME_ICON,
    platform_type: platformType(),
  };

  // Bam vao be mat quang ba (THD-02, THD-03, THD-04, THD-06)
  thdPush("select_promotion", params);

  if (opensNewTab) {
    // Tab hien tai van song -> hit gui binh thuong, khong can chan dieu huong
    thdPush("exit_to_promo_hub", { creative_slot: SLOT.HOME_ICON });
    return false;
  }

  // Cung tab: cho GTM gui xong roi moi roi trang. Mau so cua THD-08.
  const url = withSrcParam(rawUrl, THD.service_id);
  let navigated = false;
  const go = () => {
    if (navigated) return;
    navigated = true;
    window.location.href = url;
  };
  const timer = setTimeout(go, 500);

  thdPush("exit_to_promo_hub", {
    creative_slot: SLOT.HOME_ICON,
    eventTimeout: 400,
    eventCallback: function () {
      clearTimeout(timer);
      go();
    },
  });

  return true;
}

/* ------------------------------------------------------- CHIEU NGUOC (1/4) */

/* complete_mission (sheet 12) DA BO KHOI BAN TICH HOP NAY.
 * Ly do: 8 nhiem vu sd_charge_* hoan thanh NGOAI trinh duyet (USSD/SMS/he thong
 * cuoc), FE ShweDeal khong bao gio quan sat duoc. Do o GA4 se mat du lieu CO
 * THIEN LECH (chi dem duoc nguoi quay lai) va lam THD-22 cao gia.
 * THD-22 lay so tu CMS Big Promotion (bang big_promotion_request).
 * GA4 chi giu cac buoc quan sat duoc trong phien: enter_service_from_hub.
 */

/** Ten tham so thuong tren URL do trang chien dich truyen sang. */
export const MISSION_PARAM = "mission_id";

/** Chi ban enter_service_from_hub MOT lan cho moi lan tai trang. */
let entryFired = false;

/**
 * Doc mission_id tu URL cua LAN TAI TRANG nay.
 *
 * Doc truc tiep tu window.location, khong luu lai o dau: event duy nhat can
 * mission_id (enter_service_from_hub) ban ngay o lan tai trang dau tien.
 *
 * @returns {string|null} mission_id (null neu vao dich vu theo cach thong thuong)
 */
export function captureMissionIdFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    return new URLSearchParams(window.location.search).get(MISSION_PARAM) || null;
  } catch (e) {
    return null; // URL khong parse duoc
  }
}

/**
 * enter_service_from_hub — P0 — man dich cua nhiem vu — THD-21, THD-22
 *
 * Ban NGAY KHI ShweDeal tai xong man dich, khi nguoi dung vao tu duong dan
 * nhiem vu cua trang chien dich.
 *
 * KHONG ban khi:
 *  - vao ShweDeal theo cach thong thuong (URL khong co mission_id)
 *  - dieu huong noi bo trong SPA sau do (chi MOT lan moi lan tai trang)
 *
 * ĐÂY LÀ CHIỀU NGƯỢC — DỄ BỊ QUÊN NHẤT TRONG CẢ BẢN KHAI BÁO (sheet 12).
 * Thieu no thi THD-21 bang 0 va bao cao ket luan sai rang chien dich khong
 * keo duoc nguoi dung sang dich vu.
 *
 * @returns {boolean} true neu da ban
 */
export function trackEnterServiceFromHub() {
  if (entryFired) return false;

  const missionId = captureMissionIdFromUrl();
  if (!missionId) return false; // vao theo cach thong thuong

  entryFired = true;
  thdPush("enter_service_from_hub", { mission_id: missionId });
  return true;
}
